<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xQhwEG/tc-custom/9781035859580.jpg?1739848460573" alt="This image is the cover for the book Mabel Bean"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mabel Bean
      </h1>
      <p class="bookDescription body article font2">
        <p>Mabel will take you behind the scenes of a Royal Palace. Watch her perform royal duties with surprising results! This clever, question-and- answer format allows groups of readers or even single readers to actively participate in Mabel Bean’s Royal Adventure. Mabel Bean is a scruffy, fluffy, curious dog who is always putting her nose into other people’s business. Join Mabel Bean on her adventure to London and experience royal life from a dog’s eye view!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Austin J. Stack
      </h2>
      
      <p class="authorDescription body article">Born in Ireland, Austin moved to England where he met his wife of over thirty years. Throughout his life, Austin has owned a small holding, worked as a carer for additional needs adults, and used to run a wool shop in Devon. Austin began writing stories for his children, and the recent birth of his first Granddaughter has inspired him to pursue publishing his work.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5456dc4a